import {Component, inject, Input} from '@angular/core';
import {ColDef, FirstDataRenderedEvent, GridSizeChangedEvent} from "ag-grid-community";
import {IFailedRefund} from "../../interfaces/IFailedRefund";
import {AgGridAngular} from "ag-grid-angular";
import {FailedRefundTables} from "../../table-definitions/failed-refund-tables";

@Component({
  selector: 'app-failed-refunds-table',
  standalone: true,
  templateUrl: './failed-refunds-table.component.html',
  imports: [
    AgGridAngular
  ],
  styleUrls: ['./failed-refunds-table.component.css']
})
export class FailedRefundsTableComponent {

  private failedRefundTables: FailedRefundTables = inject(FailedRefundTables);

  @Input()
  public failedRefunds: IFailedRefund[] = [];

  public failedRefundColDefs: ColDef[] = this.failedRefundTables.failedRefundColDefs;

  constructor() {
  }

  gridSizeChanged(params: GridSizeChangedEvent) {
    params.api.sizeColumnsToFit();
  }

  onFirstDataRendered(params: FirstDataRenderedEvent) {
    params.api.sizeColumnsToFit();
  }
}
